module.exports = __webpack_public_path__ + "static/axis.a9616e1ea7de15eb8d1ea6465c3225ee.svg";